import { z } from "zod";

import { GuestPageVisibilityMode } from "@/lib/gql/__generated__/graphql";
import {
	PlainFontFamilySchema,
	PlainReservationComponentTypeSchema,
	PlainSettingInputSchema,
	PlainSizeTypeSchema,
	PlainWidgetDecorationSchema,
	PlainWidgetInputSchema,
} from "@/lib/zod/__generated__/validation-schema";

import {
	domainNameZodSchema,
	gtmIDZodSchema,
	hexColorZodSchema,
} from "@/components/features/_shared/validation-schema/validation-schema";

const ERROR_MESSAGES = {
	validDomainName: "ドメインは必須項目です",
};

/**
 * プレーンの設定用のバリデーションスキーマ
 */
export const PlainSettingInputZodSchema = PlainSettingInputSchema.extend({
	domainName: z.string(),
	// UI 側ではサブドメインに対してのバリデーションを行う
	subDomainName: domainNameZodSchema.min(1, { message: ERROR_MESSAGES.validDomainName }),
	gtmID: gtmIDZodSchema,

	colorBackground: hexColorZodSchema,
	colorFont: hexColorZodSchema,
	colorPrimary: hexColorZodSchema,

	// 基本設定
	isShowHotelName: z.boolean(),
	isShowHotelCatchCopy: z.boolean(),
	isShowHotelKeyVisual: z.boolean(),
	isShowHotelLogo: z.boolean(),
	logoSize: PlainSizeTypeSchema,
	fontFamily: PlainFontFamilySchema,
	reservationComponentType: PlainReservationComponentTypeSchema,

	// スナック
	widgetDecoration: PlainWidgetDecorationSchema,
	plainWidgetDefault: PlainWidgetInputSchema,

	// プレーンの公開状態（検索に表示しないかどうか）。公開設定（guestPageVisibilitySettings）として一緒に保存する
	guestPageVisibility: z.nativeEnum(GuestPageVisibilityMode),
}).refine(
	({ logoImage, isShowHotelLogo }) => {
		if (isShowHotelLogo) {
			return !!logoImage;
		}

		return true;
	},
	{
		message: "施設ロゴを表示する場合は施設ロゴを登録してください",
		path: ["logoImage", "bucket"],
	},
);

export type PlainSettingInputZodSchemaType = z.infer<typeof PlainSettingInputZodSchema>;
